import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { setTabs } from 'modules/common/Tabs/actions';
import Header from '../../../common/Header';
import { tabs } from './constants';
import BranchListContainer from '../BranchListContainer';
import SettingsContainer from '../SettingsContainer';
import BranchEditing from '../BranchEditing';
import VisitorsTabContainer from '../VisitorsTabContainer';
import DelayReasonsTabContainer from '../DelayReasonsTabContainer';

export const Admin: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTabs(tabs));
  }, []);

  return (
    <React.Fragment>
      <Header />
      <Switch>
        <Route path="/globaladmin" exact component={BranchListContainer} />
        <Route path="/globaladmin/visitors" exact component={VisitorsTabContainer} />
        <Route path="/globaladmin/delay-reasons" exact component={DelayReasonsTabContainer} />
        <Route path="/globaladmin/branch/:id" exact component={BranchEditing} />
        <Route path="/globaladmin/branch/create" exact component={BranchEditing} />
        <Route path="/globaladmin/settings" component={SettingsContainer} />
      </Switch>
    </React.Fragment>
  );
};
